import api from './api';

interface ShowcaseCreditData {
  businessId: string;
  showcaseCount: number;
  creditAmount: number;
}

interface CreditBalanceResponse {
  success: boolean;
  data: {
    balance: number;
    [key: string]: unknown;
  };
}

/**
 * Add credits to business account based on showcase count
 */
export const addShowcaseCredits = async (creditData: ShowcaseCreditData): Promise<unknown> => {
  try {
    const response = await api.post<unknown>('/business/showcase-credits', creditData);
    return response.data;
  } catch (error: unknown) {
    console.error('Error adding showcase credits:', error);
    throw error;
  }
};

/**
 * Get business credit balance
 */
export const getCreditBalance = async (businessId: string): Promise<CreditBalanceResponse> => {
  try {
    const response = await api.get<CreditBalanceResponse>(`/api/business/${businessId}/credits`);
    return response.data;
  } catch (error: unknown) {
    console.error('Error getting credit balance:', error);
    throw error;
  }
};
